export default __webpack_public_path__ + "static/chargement-benne-camion-etcheverry-mindurry-a7b65e8b980f7566fe54536ca3e8da57.jpg";